import { gql } from 'apollo-boost';

export const serviceCollectionByIdQuery = gql`
query serviceCollectionById($id: ID!) {
  allServiceCollections (filters: {id: $id}) {
    edges {
      node {
        dbId
        name
        description
        version
        services {
          edges {
            node {
              dbId
              name
            }
          }
        }
        donors {
            edges {
                node {
                    dbId
                    name
                }
            }
        }
        portfolios {
            edges {
                node {
                    dbId
                    name
                }
            }
        }
      }
    }
  }
}
`;
